import { createContext, useContext } from 'react'
import type { User } from '../api/types'

export interface AuthState {
  user: User | null
  /** True until the initial silent refresh settles. */
  loading: boolean
  login: (email: string, password: string) => Promise<void>
  acceptInvitation: (token: string, displayName: string, password: string) => Promise<void>
  isAdmin: boolean
  logout: () => Promise<void>
}

export const AuthContext = createContext<AuthState | null>(null)

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}
